export type User = {
  id: string;
  name: string;
  schoolName: string;
  isAuthenticated: boolean;
  isAdministrator: boolean;
};

export type ResponseUser = {
  organization_name: string;
  organization_id: string;
  user_name: string;
  isAuthenticated: boolean;
  isAdministrator: boolean;
};

export const buildUser = (res: ResponseUser) => {
  return {
    id: res.organization_id,
    name: res.user_name,
    schoolName: res.organization_name,
    isAuthenticated: res.isAuthenticated,
    isAdministrator: res.isAdministrator,
  };
};
